import React from 'react';

import ScarcityOne from '../../icons-af/scarcity-one';
import ScarcityLimited from '../../icons-af/scarcity-limited';
import './scarcity.scss';

const Scarcity = ({remaining, isUnique}: propTypes) => {
  const icon = !isUnique ? (
    <ScarcityLimited width="22" height="20" />
  ) : (
    <ScarcityOne width="22" height="20" />
  );
  return (
    <div className="scarcityContainer">
      {icon}
      <span className="scarcityAmount">
        {!isUnique ? (
          <span>
            <strong>Limited edition!</strong> Only {remaining} copies left.
          </span>
        ) : (
          <strong>One of a kind artwork</strong>
        )}
      </span>
    </div>
  );
};

interface propTypes {
  remaining: number;
  isUnique: boolean;
}

export default Scarcity;
